<template>
    <v-btn size="small" :to="to" color="primary" variant="text" icon="mdi-eye" />
</template>

<script setup lang="ts">
defineProps({
    to: {
        type: String,
        required: true,
    },
});
</script>
